import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  DropdownItem,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Spinner,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Controller, useForm } from 'react-hook-form';
import * as _ from 'lodash';

import {
  BackButton,
  CancelButton,
  GeneralErrors,
  KebabDropdown,
  PageHeader,
} from '../../components';
import { updateReport } from '../../redux/reports/actions';
import { useConfirmAction, useReadOnly } from '../../utils/hooks';

import layout from '../../styles/layout.module.scss';
import { PathogenMultiselect } from '../../components/inputs/PathogenMultiselect';

export default function ParasitesForm ({ currReport }) {
  const readOnly = useReadOnly();
  const history = useHistory();
  const dispatch = useDispatch();
  const confirmAction = useConfirmAction();
  const {
    handleSubmit,
    formState,
    control,
  } = useForm({ defaultValues: currReport });

  const { isSubmitted } = formState;

  const pending = useSelector((s) => s.reports.changeReportPending);
  const error = useSelector((s) => s.reports.changeReportError);
  const submitSuccess = isSubmitted && !pending && !error;

  const submit = useCallback((data) => {
    dispatch(updateReport({
      ...data,
      parasites: _.map(_.get(data, 'parasites', []), 'id'),
      id: currReport.id,
    }));
  }, [currReport]);

  const removeParasites = useCallback(() => {
    confirmAction({
      action: 'remove',
      subjectType: 'parasites',
      subject: 'this detail',
      onConfirm: () => dispatch(updateReport({
        parasites: [],
        id: currReport.id,
      })),
      pendingPath: 'reports.changeReportPending',
      errorPath: 'reports.changeReportError',
      onSuccess: history.goBack,

    });
  }, [currReport, confirmAction]);

  // Submit success
  useEffect(() => {
    if (submitSuccess) {
      history.goBack();
    }
  }, [submitSuccess]);

  return (
    <div className={layout.page}>
      <PageHeader
        title="Parasites"
        coverMenu
      >
        <BackButton/>
        {
          (
            !readOnly &&
            _.get(currReport, 'parasites.length', 0) > 0
          ) && (
            <KebabDropdown right>
              <DropdownItem onClick={removeParasites}>
                <FontAwesomeIcon icon="trash" />
                Remove Parasites
              </DropdownItem>
            </KebabDropdown>
          )
        }
      </PageHeader>
      <div className={layout.pageContent}>
        <div className={layout.responsiveContainer}>
          {!currReport ?
            <div className="text-center">
              <Spinner />
            </div>
            :
            <Form
              className={layout.responsiveContainer}
              onSubmit={handleSubmit(submit)}
            >
              <FormGroup>
                <Label>Parasites</Label>
                <Controller
                  as={PathogenMultiselect}
                  name="parasites"
                  placeholder="Select Parasites"
                  control={control}
                  invalid={ isSubmitted && _.has(error, 'parasites') }
                  filter={
                    [
                      'apicomp', 'acanth', 'cestodes', 'crust',
                      'micro', 'monodig', 'myxo', 'nema', 'pro', 'other',
                    ]
                  }
                />
                <FormFeedback role="alert">
                  { _.get(error, 'parasites') }
                </FormFeedback>
              </FormGroup>
              { isSubmitted && <GeneralErrors error={error} /> }
              { !readOnly && (
                <Button
                  color="primary"
                  disabled={pending}
                  block
                >
                  Save{' '}
                  { pending && <Spinner size="sm" /> }
                </Button>
              )}
              <CancelButton />
            </Form>
          }
        </div>
      </div>
    </div>
  );
}
